import React from "react";
import { useIntl } from "react-intl";
import { Calendar } from "@piiqtechnologies/svg-icons";
import { PeekPaper, PeekSelect, PeekStack, PeekTypography } from "@piiqtechnologies/ui-components";
import messages from "./messages.i18n";
import FilterDatesForm from "./FilterDatesForm";
export const FilterDatesButton = ({ handleNewDateRange }) => {
    const intl = useIntl();
    return (React.createElement(React.Fragment, null,
        React.createElement(PeekSelect, { displayEmpty: true, renderValue: (_value) => (React.createElement(PeekStack, { direction: "row", alignItems: "center", spacing: 1 },
                React.createElement(Calendar, { fontSize: "16px" }),
                React.createElement(PeekTypography, { variant: "h4" }, intl.formatMessage(messages.filterDates)))) },
            React.createElement(PeekPaper, { elevation: 3, sx: { maxWidth: "267px" } },
                React.createElement(FilterDatesForm, { handleNewDateRange: (values) => handleNewDateRange(values) })))));
};
export default FilterDatesButton;
